var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"memoEditWindow"},[_c('menubar',{attrs:{"from":"memoEdit"}}),_c('memo-edit',{attrs:{"memoData":_vm.memoData,"topOffset":_vm.topOffset},on:{"close":_vm.handleClose,"saved":_vm.handleSaved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }